import React from 'react'

export default function IconsLineChart({ color = '#463DFB', className = 'icons-icon', style = {} }) {
    return (
        <svg
            className={className}
            style={style}
            width='14'
            height='14'
            viewBox='0 0 14 14'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M0.625 0.625V11.2917C0.625 11.6453 0.765476 11.9844 1.01552 12.2345C1.26557 12.4845 1.60471 12.625 1.95833 12.625H12.625'
                stroke={color}
                strokeWidth='1.25'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M10.625 9.95833V4.625'
                stroke={color}
                strokeWidth='1.25'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M7.29163 9.9585V1.9585'
                stroke={color}
                strokeWidth='1.25'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M3.95837 9.9585V7.9585'
                stroke={color}
                strokeWidth='1.25'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
        </svg>
    )
}
